import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { LocalWebTicket, RelatedCard, RidangoReduxAction } from '@ridango/core';

import { AccountTicketsActions } from './account-tickets.actions';
import { AccountTicketsPartialStoreState } from './account-tickets.reducer';
import * as AccountTicketsSelectors from './account-tickets.selectors';

@Injectable()
export class AccountTicketsFacade {
    loaded$ = this.store.select(AccountTicketsSelectors.getLoaded);
    error$ = this.store.select(AccountTicketsSelectors.getError);

    selectedTicket$ = this.store.select(AccountTicketsSelectors.getSelectedTicket);

    accountTickets$ = this.store.select(AccountTicketsSelectors.getAccountTickets);
    accountEmailTickets$ = this.store.select(AccountTicketsSelectors.getAccountEmailTickets);
    accountVoucherTickets$ = this.store.select(AccountTicketsSelectors.getAccountVoucherTickets);

    selectedRelatedCardTickets$ = this.store.select(AccountTicketsSelectors.getSelectedRelatedCardTickets);

    constructor(
        private store: NgRedux<AccountTicketsPartialStoreState>,
        private actions: AccountTicketsActions
    ) {}

    dispatch(action: RidangoReduxAction) {
        this.store.dispatch(action);
    }

    fetchAccountTickets() {
        this.dispatch(this.actions.fetchAccountTickets());
    }

    fetchRelatedCardTickets(card: RelatedCard) {
        this.dispatch(this.actions.fetchAccountRelatedCardTickets(card));
    }

    setSelectedTicket(ticket: LocalWebTicket) {
        this.dispatch(this.actions.setSelectedAccountTicket(ticket));
    }

    resetAccountTickets() {
        this.dispatch(this.actions.resetAccountTickets());
    }
}
